import { Charts } from './Charts';
import GeneralProductionChartsDataProvider from './contexts/GeneralProductionChartsDataContext';

const GeneralProductionWrapper = () => {
    return (
        <GeneralProductionChartsDataProvider>
            <Charts />
        </GeneralProductionChartsDataProvider>
    );
};

export default GeneralProductionWrapper;
